import { render, staticRenderFns } from "./prolist.vue?vue&type=template&id=1d706c90&"
import script from "./prolist.vue?vue&type=script&lang=js&"
export * from "./prolist.vue?vue&type=script&lang=js&"
import style0 from "./prolist.vue?vue&type=style&index=0&id=1d706c90&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports